module.exports = __webpack_public_path__ + "img/logo-humanscale@2x.5b78b086.png";